<template>
    <a @click="handleClick" href="javascript:void(0);" class="card class" :class="{ 'mb': mb }">
        <div class="card-body">
            <div v-if="isFreeClass" class="label">Free class</div>
            <img class="card-img-top-virtuoso" :src="vodClass.imageUris ? vodClass.imageUris.cardThumb.url : ''" :alt="vodClass.name" loading="lazy">

            <h3 v-if="lessonNum" class="grey-subtitle">Class {{ lessonNum }}</h3>

            <h2 class="card-title">{{ vodClass.name }}</h2>

            <hr>

            <p class="card-text">{{ vodClass.description_short }}</p>
            <p class="card-text" v-if="vodClass.video">
                <strong>
                    Class length: {{ vodClass.video.durationFormatted }}
                </strong>
            </p>
            <div class="btn-area" v-if="showBtns">
                <template v-if="isEnrolled">
                    <button class="btn btn-primary btn-main">Watch class</button>
                </template>
                <template v-else>
                    <template v-if="vodClass.is_free">
                        <button class="btn btn-info btn-block btn-main">Watch free class</button>
                    </template>
                    <template v-else>
                        <button class="btn btn-primary btn-block btn-main">Read more</button>
                    </template>
                </template>
            </div>
        </div>

        <template v-if="!isEnrolled">
            <b-modal modal-class="class-modal" :id="'classModal-' + vodClass.id" size="xl" :hide-header="true" :ok-only="true" ok-variant="link" ok-title="Close" centered>

                <h1 class="class-modal-header">{{ vodClass.name }}</h1>

                <div class="body">
                    <div class="row justify-content-center">
                        <div class="col-md-10">

                            <hr>

                            <div class="text-center meta-info-modal" v-if="vodClass.video">
                                Duration: {{ vodClass.video.durationFormatted }}
                            </div>

                            <!-- Top text area -->
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="description">
                                        <h2>About the Lesson</h2>
                                        <span v-html="vodClass.descriptionLongHTML"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="video mt-3" v-if="vodClass.is_free == true">
                                <h2>Watch the class</h2>
                                <div v-if="isAuth">
                                    <mux-video-component
                                        type="vod-class"
                                        :entity="vodClass"
                                        :track-start="true"></mux-video-component>
                                </div>
                                <div v-else>
                                    <p class="text-center">To watch this class for free please create an account (no credit card required)</p>
                                    <p class="text-center">
                                        <a :href="'/register?return=' + vodClass.course.uri" class="btn btn-primary">Register</a>
                                    </p>
                                </div>
                            </div>

                            <div class="video mt-3" v-if="vodClass.youtubeEmbed != null">
                                <h2>Watch the video</h2>
                                <span v-html="vodClass.youtubeEmbed"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
        </template>
    </a>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            vodClassData: {
                type: Object,
                default: null
            },
            mb: {
                type: Boolean,
                default: false
            },
            lessonNum: {
                type: Number,
                required: false,
            },
            isEnrolled: {
                type: Boolean,
                required: false,
                default: false,
            },
            showBtns: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                vodClass: {},
                isAuth: false,
                isFreeClass: false,
            }
        },

        mounted() {
            if(this.vodClassData) {
                this.vodClass = this.vodClassData;
            } else {
                this.getClass();
            }

            if(this.vodClass.is_free) {
                this.isFreeClass = true;
            }

            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;

                    if(window.virtuoso.user.isSchoolUser) {
                        this.isFreeClass = false; // School users shouldn't have free classes
                    }
                }
            }
        },

        computed: {
            // Vue complains if we just access imageUris directly
            topBanner: function () {
                return this.vodClass.imageUris ? this.vodClass.imageUris.topBanner.url : '';
            }
        },

        methods: {
            getClass: function() {
                axios.get('/api/vod_classes/' + this.id)
                    .then((response) => {
                        this.vodClass = response.data;
                    });
            },
            handleClick: function() {
                if(this.isEnrolled) {
                    location.href = this.vodClass.classroomUri;
                    return true;
                }

                this.$bvModal.show('classModal-' + this.vodClass.id);
            }
        }
    }
</script>
